/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Sortby_Releasedate2Inputs */

const id_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal Rilis`)
};

const ms_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh Keluaran`)
};

const da_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udgivelsesdato`)
};

const de_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichungsdatum`)
};

const en_us2_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release Date`)
};

const es_es2_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de lanzamiento`)
};

const es_mx2_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de lanzamiento`)
};

const fil_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petsa ng Release`)
};

const fr_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de sortie`)
};

const it_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data di uscita`)
};

const hu_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megjelenés dátuma`)
};

const nl_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Releasedatum`)
};

const no_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utgivelsesdato`)
};

const pl_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data wydania`)
};

const pt_br2_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de lançamento`)
};

const pt_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de lançamento`)
};

const ro_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data lansării`)
};

const fi_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Julkaisupäivä`)
};

const sv_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Releasedatum`)
};

const vi_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày phát hành`)
};

const tr_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çıkış Tarihi`)
};

const cs_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum vydání`)
};

const bg_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата на издаване`)
};

const ru_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата выхода`)
};

const uk_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата виходу`)
};

const ar_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ الإصدار`)
};

const hi_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिलीज़ तारीख़`)
};

const th_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่วางจำหน่าย`)
};

const ja_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リリース日`)
};

const zh_cn2_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布日期`)
};

const zh_hant1_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`發布日期`)
};

const ko_tags_sortby_releasedate2 = /** @type {(inputs: Tags_Sortby_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출시일`)
};

/**
* | output |
* | --- |
* | "Release Date" |
*
* @param {Tags_Sortby_Releasedate2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const tags_sortby_releasedate2 = /** @type {((inputs?: Tags_Sortby_Releasedate2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Sortby_Releasedate2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tags_sortby_releasedate2(inputs)
	if (locale === "ms") return ms_tags_sortby_releasedate2(inputs)
	if (locale === "da") return da_tags_sortby_releasedate2(inputs)
	if (locale === "de") return de_tags_sortby_releasedate2(inputs)
	if (locale === "en-US") return en_us2_tags_sortby_releasedate2(inputs)
	if (locale === "es-ES") return es_es2_tags_sortby_releasedate2(inputs)
	if (locale === "es-MX") return es_mx2_tags_sortby_releasedate2(inputs)
	if (locale === "fil") return fil_tags_sortby_releasedate2(inputs)
	if (locale === "fr") return fr_tags_sortby_releasedate2(inputs)
	if (locale === "it") return it_tags_sortby_releasedate2(inputs)
	if (locale === "hu") return hu_tags_sortby_releasedate2(inputs)
	if (locale === "nl") return nl_tags_sortby_releasedate2(inputs)
	if (locale === "no") return no_tags_sortby_releasedate2(inputs)
	if (locale === "pl") return pl_tags_sortby_releasedate2(inputs)
	if (locale === "pt-BR") return pt_br2_tags_sortby_releasedate2(inputs)
	if (locale === "pt") return pt_tags_sortby_releasedate2(inputs)
	if (locale === "ro") return ro_tags_sortby_releasedate2(inputs)
	if (locale === "fi") return fi_tags_sortby_releasedate2(inputs)
	if (locale === "sv") return sv_tags_sortby_releasedate2(inputs)
	if (locale === "vi") return vi_tags_sortby_releasedate2(inputs)
	if (locale === "tr") return tr_tags_sortby_releasedate2(inputs)
	if (locale === "cs") return cs_tags_sortby_releasedate2(inputs)
	if (locale === "bg") return bg_tags_sortby_releasedate2(inputs)
	if (locale === "ru") return ru_tags_sortby_releasedate2(inputs)
	if (locale === "uk") return uk_tags_sortby_releasedate2(inputs)
	if (locale === "ar") return ar_tags_sortby_releasedate2(inputs)
	if (locale === "hi") return hi_tags_sortby_releasedate2(inputs)
	if (locale === "th") return th_tags_sortby_releasedate2(inputs)
	if (locale === "ja") return ja_tags_sortby_releasedate2(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_sortby_releasedate2(inputs)
	if (locale === "zh-Hant") return zh_hant1_tags_sortby_releasedate2(inputs)
	return ko_tags_sortby_releasedate2(inputs)
});
export { tags_sortby_releasedate2 as "tags.sortBy.releaseDate" }